import { render, staticRenderFns } from "./plus.vue?vue&type=template&id=65c70a88&scoped=true&"
import script from "./plus.vue?vue&type=script&lang=js&"
export * from "./plus.vue?vue&type=script&lang=js&"
import style0 from "./plus.vue?vue&type=style&index=0&id=65c70a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c70a88",
  null
  
)

export default component.exports